
<div *ngIf="canAccess" class="relative dashboard-box lg:col-span-2 ">
  <div class="absolute inset-px rounded-[16px]"></div>
  <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">
    <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header">
      <h2 class="text-xl text-white font-semibold w-fit mb-0">Log de errores</h2>
    </div>
    <div class="@container relative min-h-[15rem] w-full grow max-lg:mx-auto max-lg:max-w-sm px-2 lg:px-8">
      <div class="flex mt-6 mb-6 inset-x-0 bottom-0">
        <div *ngIf="loading" class="w-full text-center">
          <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
        </div>

        <app-generic-list class="w-full flex-col" *ngIf="itemsList.length > 0 && !loading"
                          filterKeyPrefix="calls-pricing"
                          [items]="itemsList"
                          (itemClick)="onItemClick($event)"
                          [filterFields]="filterItems"
                          [showFilters]="true"
                          [isFiltersCollapsed]="true"
                          [allowDownload]="true"
                          (pageChanged)="loadMore()"
                          (filteredCount)="filteredCounts.itemsList = $event"
                          [pageSize]="7">

          <!--
            Error: "\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : 'Db_limitpromo'\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value\nError : cannot access local variable 'sub' where it is not associated with a value"
            PhoneNumber: "N/A"
            createdAt: "2025-06-19T19:34:22.548Z"
            eventInput: {}
            id: "05f83028-cc6d-44f4-b0ca-d9eadf2f43c9"
            identifier: "N/A"
            nombrefuncion: "crmUpsertPromo"
            plataforma: "Web"
            version: "1.0.0"
          -->

          <ng-template #tableHeaderTemplate>
            <div class="flex items-center border-b py-2 font-semibold text-sm text-gray-700">
              <div class="w-[200px] truncate text-gray-500 mr-4">Función</div>
              <div class="w-[700px] truncate text-gray-500 mr-4">Error</div>
              <div class="w-[120px] truncate text-gray-500 mr-4">Fecha</div>
            </div>
          </ng-template>

          <ng-template #itemTemplate let-item>
            <div class="flex items-center border-b py-2 text-sm overflow-x-auto">
              <div class="w-[200px] truncate overflow-hidden whitespace-nowrap font-bold mr-4">{{ item.nombrefuncion }}</div>
              <div class="w-[700px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4">{{ item.Error }}</div>
              <div class="w-[120px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4">{{ item.createdAt | date:'dd/MM/yyyy' }}</div>
            </div>
          </ng-template>

          <div *ngIf="filteredCounts.itemsList == 0 && !loading" class="w-full content-center h-[200px]">
            <div class="!font-medium text-center">
              <mat-icon class="!text-[100px] !size-[100px]" style="color:#cfcfcf;">people</mat-icon><br />
              No se encontraron tarifas
            </div>
          </div>
        </app-generic-list>
      </div>
    </div>
  </div>
  <!--<div>
    <button mat-button color="primary" (click)="onNewItem()">{{ 'COMPONENTS.PROFILE.CREATE' | translate }}</button>
  </div>-->
  <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
</div>
